import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import React, { useState, useCallback } from 'react';
const INITIAL_FILTER_STATE = {
    grayscale: 0,
    sepia: 0,
    blur: 0,
    brightness: 1,
    contrast: 1,
    shadow: 0,
    rotate: 0,
    invert: 0,
    opacity: 1,
    saturate: 1,
};
export const useImageFilter = (messages) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    const [filter, setFilterState] = useState(INITIAL_FILTER_STATE);
    const [selectedFilter, setSelectedFilter] = useState('');
    const [filterAsString, setFilterAsString] = useState('');
    const options = [
        ['sepia', (_a = messages === null || messages === void 0 ? void 0 : messages.editor) === null || _a === void 0 ? void 0 : _a.filter_sepia],
        ['grayscale', (_b = messages === null || messages === void 0 ? void 0 : messages.editor) === null || _b === void 0 ? void 0 : _b.filter_grayscale],
        ['blur', (_c = messages === null || messages === void 0 ? void 0 : messages.editor) === null || _c === void 0 ? void 0 : _c.filter_blur],
        ['brightness', (_d = messages === null || messages === void 0 ? void 0 : messages.editor) === null || _d === void 0 ? void 0 : _d.filter_brightness],
        ['contrast', (_e = messages === null || messages === void 0 ? void 0 : messages.editor) === null || _e === void 0 ? void 0 : _e.filter_contrast],
        ['hue-rotate', (_f = messages === null || messages === void 0 ? void 0 : messages.editor) === null || _f === void 0 ? void 0 : _f.filter_hueRotate],
        ['invert', (_g = messages === null || messages === void 0 ? void 0 : messages.editor) === null || _g === void 0 ? void 0 : _g.filter_invert],
        ['opacity', (_h = messages === null || messages === void 0 ? void 0 : messages.editor) === null || _h === void 0 ? void 0 : _h.filter_opacity],
        ['saturate', (_j = messages === null || messages === void 0 ? void 0 : messages.editor) === null || _j === void 0 ? void 0 : _j.filter_saturate],
    ];
    const setFilter = useCallback((e) => {
        const element = e.target;
        const val = Number(element.value);
        setFilterState((prev) => {
            const newFilter = Object.assign({}, prev);
            switch (element.name) {
                case 'grayscale':
                    newFilter.grayscale = val;
                    break;
                case 'sepia':
                    newFilter.sepia = val;
                    break;
                case 'blur':
                    newFilter.blur = val;
                    break;
                case 'brightness':
                    newFilter.brightness = val;
                    break;
                case 'contrast':
                    newFilter.contrast = val;
                    break;
                case 'drop-shadow':
                    newFilter.shadow = val;
                    break;
                case 'hue-rotate':
                    newFilter.rotate = val;
                    break;
                case 'invert':
                    newFilter.invert = val;
                    break;
                case 'opacity':
                    newFilter.opacity = val;
                    break;
                case 'saturate':
                    newFilter.saturate = val;
                    break;
            }
            let _filterAsString = '';
            for (const [key, value] of Object.entries(newFilter)) {
                if (value !== 0) {
                    if (key === 'rotate') {
                        _filterAsString += `hue-rotate(${value}deg) `;
                    }
                    else if (key === 'blur') {
                        _filterAsString += `${key}(${value}px) `;
                    }
                    else {
                        _filterAsString += `${key}(${value}) `;
                    }
                }
            }
            setFilterAsString(_filterAsString);
            return newFilter;
        });
    }, []);
    const setFilterSlider = useCallback((nameF, valueF) => {
        setSelectedFilter(valueF);
    }, []);
    const resetFilters = useCallback(() => {
        setFilterState(INITIAL_FILTER_STATE);
        setFilterAsString('');
        setSelectedFilter('');
    }, []);
    // Dynamic slider configuration based on the current state
    const getSliderConfig = (valueF) => {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        let min = 0, max = 1, step = 0.1, defaultValue = 0, currentValue = 0, message = '';
        switch (valueF) {
            case 'blur':
                max = 10;
                step = 1;
                currentValue = filter.blur;
                message = (_a = messages === null || messages === void 0 ? void 0 : messages.editor) === null || _a === void 0 ? void 0 : _a.filter_blur;
                break;
            case 'brightness':
                max = 3;
                defaultValue = 1;
                currentValue = filter.brightness;
                message = (_b = messages === null || messages === void 0 ? void 0 : messages.editor) === null || _b === void 0 ? void 0 : _b.filter_brightness;
                break;
            case 'contrast':
                max = 3;
                defaultValue = 1;
                currentValue = filter.contrast;
                message = (_c = messages === null || messages === void 0 ? void 0 : messages.editor) === null || _c === void 0 ? void 0 : _c.filter_contrast;
                break;
            case 'hue-rotate':
                max = 360;
                step = 1;
                currentValue = filter.rotate;
                message = (_d = messages === null || messages === void 0 ? void 0 : messages.editor) === null || _d === void 0 ? void 0 : _d.filter_hueRotate;
                break;
            case 'saturate':
                max = 3;
                defaultValue = 1;
                currentValue = filter.saturate;
                message = (_e = messages === null || messages === void 0 ? void 0 : messages.editor) === null || _e === void 0 ? void 0 : _e.filter_saturate;
                break;
            case 'sepia':
                currentValue = filter.sepia;
                message = (_f = messages === null || messages === void 0 ? void 0 : messages.editor) === null || _f === void 0 ? void 0 : _f.filter_sepia;
                break;
            case 'grayscale':
                currentValue = filter.grayscale;
                message = (_g = messages === null || messages === void 0 ? void 0 : messages.editor) === null || _g === void 0 ? void 0 : _g.filter_grayscale;
                break;
            case 'invert':
                currentValue = filter.invert;
                message = (_h = messages === null || messages === void 0 ? void 0 : messages.editor) === null || _h === void 0 ? void 0 : _h.filter_invert;
                break;
            case 'opacity':
                defaultValue = 1;
                currentValue = filter.opacity;
                message = (_j = messages === null || messages === void 0 ? void 0 : messages.editor) === null || _j === void 0 ? void 0 : _j.filter_opacity;
                break;
        }
        return { min, max, step, defaultValue, currentValue, message };
    };
    // Renders the slider live using the current value from filter
    const renderSlider = () => {
        var _a;
        if (!selectedFilter || selectedFilter === 'default')
            return null;
        const config = getSliderConfig(selectedFilter);
        return (_jsxs("div", { children: [_jsxs("label", { htmlFor: selectedFilter, children: [config.message + ' ' + currentFilterData + ' / ', " ", (_a = messages === null || messages === void 0 ? void 0 : messages.editor) === null || _a === void 0 ? void 0 : _a.filter_default, ": ", config.defaultValue] }), _jsx("input", { type: "range", id: selectedFilter, name: selectedFilter, min: config.min, max: config.max, step: config.step, value: config.currentValue, onChange: setFilter })] }, selectedFilter));
    };
    const currentFilterData = selectedFilter ? getSliderConfig(selectedFilter).currentValue.toString() : '';
    return {
        filter,
        filterAsString,
        currentFilterData,
        renderSlider,
        options,
        setFilterSlider,
        resetFilters,
    };
};
